var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"container-card el-row"},[_c('Channels')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }